import { Injectable } from "@angular/core";
import { CheckRegisterRequest, CheckRegisterResponse, ConfirmRegisterUserPayload, ConfirmRegisterUserResponse, MyVehicleAllResponse, RegisterUserPayload, RegisterUserResponse, UpdateNamePayload } from "../../../models/user.model";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { ConfigService } from "../../config.service";
import { ApiMethodService } from "../../../../tools/services/api/method-api/apiMethod.service";
import { Observable } from "rxjs";
import { environment } from '../../../../../environments/environment';
import { RegisterMemberNewPayload } from "../../../models/member.model";
import { MyMemberCard, StatusAPIResponse } from "../../../models/information.model";
import { ActivateMemberPayload, CardByVehicleTypeInfo } from "../../../models/activate.model";

@Injectable({
  providedIn: 'root',
})

export class ApiMemberCardService {
  private tokenUrl = `${environment.apiPrivateUrl}`;

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private apiMethods: ApiMethodService,
  ) { }
  RegisterMemberCard(
    body: RegisterMemberNewPayload,
    token: string,
  ): Observable<StatusAPIResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    console.log("📨 Sent Api Register Member Card Form : ", this.tokenUrl + '/Cityparking/RegisterMemberCard', headers, body, JSON.stringify(body,null,2));
    return this.http.post<StatusAPIResponse>(
      this.tokenUrl + '/Cityparking/RegisterMemberCard',
      body,
      { headers },
    );
  }

  postSaveActiveMemberCard(
    token: string,
    payload: ActivateMemberPayload,
  ): Observable<StatusAPIResponse> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    console.log(
      '📨 Sent Api Active Member Card Form : ',
      this.tokenUrl + '/Cityparking/ActivateMemberCard',
      headers,
      payload,
    );

    return this.http.post<StatusAPIResponse>(
      this.tokenUrl + '/Cityparking/ActivateMemberCard',
      payload,
      {
        headers,
      },
    );
  }

  getCardInfoByCardCode(
    uid: string,
    siteId: number,
    cardCode: string,
    token: string,
  ): Observable<CardByVehicleTypeInfo> {
    console.log('this Token : ', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.tokenUrl + '/Cityparking/GetCardInfoByCardCode';
    const params = new HttpParams()
      .set('siteId', siteId)
      .set('uid', uid)
      .set('cardCode', cardCode);
    console.log(
      '📨 Sent Api GetCardInfoByCardCode : ',
      url,
      headers,
      params.toString(),
    );
    return this.http.get<CardByVehicleTypeInfo>(url, {
      headers,
      params,
    });
  }

  getVehicleMemberCardInfo(
    token: string,
    uid: string,
    siteId: number,
    cardCode: string,
    anotherParam?: string,
  ): Observable<MyVehicleAllResponse[]> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    // 👉 ใช้ HttpParams สำหรับจัดการ query string
    let params = new HttpParams()
      .set('uid', uid)
      .set('siteId', siteId.toString())
      .set('cardCode', cardCode);

    if (anotherParam) {
      params = params.set('anotherParam', anotherParam);
    }
    const url = `${this.tokenUrl}/Cityparking/GetVehicleMemberCardInfo`;
    return this.http.get<MyVehicleAllResponse[]>(url, { headers, params });
  }

  getMyMemberCardNotExpired(
    token: string,
    uid: string,
  ): Observable<MyMemberCard[]> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.tokenUrl + `/Cityparking/GetMyMemberCardNotExpired?uid=${uid}`;
    return this.http.get<MyMemberCard[]>(url, { headers });
  }

  getCardByVehicleTypeInfo(
    uid: string,
    siteId: number,
    vehicleTypeId: number,
    count: number,
    token: string,
  ): Observable<CardByVehicleTypeInfo[]> {
    console.log('this Token : ', token);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const url = this.tokenUrl + '/Cityparking/GetCardInfoByVehicleType';
    const params = new HttpParams()
      .set('siteId', siteId)
      .set('uid', uid)
      .set('vehicleTypeId', vehicleTypeId)
      .set('count', count);
    console.log(
      '📨 Sent Api GetCardInfoByVehicleType : ',
      url,
      headers,
      params.toString(),
    );
    return this.http.get<CardByVehicleTypeInfo[]>(url, {
      headers,
      params,
    });
  }

}